import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip /me — AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
      setTenant(r.data.tenant);
      setEmployee(r.data.employee);
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
    setTenant(null);
    setEmployee(null);
    window.location.href = "/";
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, employee, loading, setUser, setTenant, setEmployee, logout, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
